<template>
  <div class="replay-view-container">
    <div class="player-wrapper">
      <div class="empty_height2">
        <div v-if="video" style="display: flex; justify-content: space-between; align-items: center;">
          <span>{{ video.text1 }} {{ video.text2 }}</span>
          <div style="display: flex; align-items: center">
            <span>File Size {{ video.byte_text }}</span>
            <a-button ghost shape="circle" style="background: #495057; margin-left: 12px" @click="handleClickDownload">
              <template #icon><download-outlined /></template>
            </a-button>
            <a-button ghost shape="circle" style="background: #495057; margin-left: 4px" @click="handleClickDelete">
              <template #icon><delete-outlined /></template>
            </a-button>
          </div>
        </div>
      </div>
      <div class="player" v-if="video">
        <video-player :options="{ sources: [{ src: video.mp4, type: 'video/mp4' }] }" />
      </div>
      <div style="display: flex; justify-content: flex-end" v-if="video">
        <!-- <span>Speed {{}} <a-divider type="vertical" />GPS {{}}</span> -->
      </div>
    </div>
    <div class="map-wrapper">
      <div class="empty_height" />
      <google-map :crashCar="path" :id="id" :style="{ borderRadius: '8px' }" />
    </div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import productService from '../services/product';
import { saveAs } from 'file-saver';
import { DownloadOutlined, DeleteOutlined } from '@ant-design/icons-vue';
import VideoPlayer from '../components/VideoPlayer.vue';
import GoogleMap from '../components/GoogleMap.vue';
import { Modal } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { createVNode } from 'vue';

export default {
  components: {
    VideoPlayer,
    GoogleMap,
    DownloadOutlined,
    DeleteOutlined,
  },
  data() {
    return {
      video: null,
      id: '0',
      path: [],
      emptyHeight: 0,
    };
  },
  async mounted() {
    const route = useRoute();
    const id = route.params.id;
    if (id) {
      this.id = id;
      this.update(id);
    }
  },
  methods: {
    async update(id) {
      const res = await productService.fetchVideo(id);
      if (!res.r) {
        alert(res.msg);
        return;
      }
      this.video = res;
      
      const trackArray = [];
      if(res.event_data && res.event_data.latitude && res.event_data.longitude) {
        if(res.event_data.latitude == 0 && res.event_data.longitude == 0) {
          return;
        }
        trackArray.push({
          lat: res.event_data.latitude,
          lng: res.event_data.longitude
        });
      }
      this.path = trackArray;
      
      //test 값
      // https://www.echomasteropsis.com/map?p=41.908271,-87.837278&speed=37&direction=88.800000&p=41.908205,-87.840975&speed=37&direction=88.900000&p=41.908136,-87.844950&speed=37&direction=88.400000&p=41.908072,-87.848568&speed=37&direction=88.200000&p=41.908210,-87.847148&speed=37&direction=268.700000&p=41.908287,-87.843598&speed=37&direction=268.300000&p=41.908348,-87.839951&speed=37&direction=268.500000&p=41.908434,-87.835987&speed=37&direction=268.300000&p=41.908479,-87.832384&speed=37&direction=267.900000&p=41.908319,-87.834977&speed=37&direction=88.200000&p=41.908246,-87.838890&speed=37&direction=88.800000&p=41.908177,-87.842790&speed=37&direction=88.700000&p=41.908108,-87.846438&speed=37&direction=88.700000&p=41.908179,-87.849121&speed=37&direction=268.700000&p=41.908240,-87.845561&speed=37&direction=268.100000&p=41.908315,-87.841983&speed=37&direction=268.900000&p=41.908385,-87.838203&speed=37&direction=268.300000&p=41.908463,-87.834471&speed=37&direction=268.800000&p=41.908356,-87.832569&speed=37&direction=89.200000&p=41.908296,-87.836025&speed=37&direction=88.400000&p=41.908215,-87.839950&speed=37&direction=89.400000&p=41.908163,-87.843540&speed=37&direction=88.500000&p=41.908091,-87.847445&speed=37&direction=88.600000&p=41.908191,-87.848400&speed=37&direction=268.800000&p=41.908263,-87.844636&speed=37&direction=268.200000&p=41.908330,-87.840981&speed=37&direction=268.700000&p=41.908402,-87.837397&speed=37&direction=268.300000&p=41.908471,-87.833664&speed=37&direction=269.600000&p=41.908338,-87.833907&speed=37&direction=88.500000&p=41.908268,-87.837480&speed=37&direction=88.800000&p=41.908199,-87.841378&speed=37&direction=88.900000&p=41.908135,-87.845033&speed=37&direction=88.400000&p=41.908065,-87.848881&speed=37&direction=88.200000&p=41.908214,-87.846946&speed=37&direction=268.700000&p=41.908291,-87.843395&speed=37&direction=268.700000&p=41.908353,-87.839704&speed=37&direction=268.500000&p=41.908439,-87.835785&speed=37&direction=268.300000&p=41.908484,-87.832183&speed=37&direction=267.900000&p=41.908323,-87.834760&speed=37&direction=88.700000&p=41.908252,-87.838487&speed=37&direction=88.800000&p=41.908190,-87.841984&speed=37&direction=88.700000&p=41.908115,-87.845996&speed=37&direction=88.700000&p=41.908046,-87.849687&speed=37&direction=182.600000&p=41.908230,-87.845984&speed=37&direction=268.100000&p=41.908308,-87.842387&speed=37&direction=268.700000&p=41.908369,-87.838933&speed=37&direction=268.400000&p=41.908456,-87.834967&speed=37&direction=268.800000&p=41.908356,-87.832569&speed=37&direction=89.200000&p=41.908296,-87.836025&speed=37&direction=88.400000&p=41.908215,-87.839950&speed=37&direction=89.400000&p=41.908163,-87.843540&speed=37&direction=88.500000&p=41.908091,-87.847445&speed=37&direction=88.600000&p=41.908191,-87.848400&speed=37&direction=268.800000&p=41.908263,-87.844636&speed=37&direction=268.200000&p=41.908330,-87.840981&speed=37&direction=268.700000&p=41.908402,-87.837397&speed=37&direction=268.300000&p=41.908471,-87.833664&speed=37&direction=269.600000&p=0.000000,0.000000&speed=0&direction=0.000000&p=0.000000,0.000000&speed=0&direction=0.000000&p=0.000000,0.000000&speed=0&direction=0.000000&p=0.000000,0.000000&speed=0&direction=0.000000&p=0.000000,0.000000&speed=0&direction=0.000000&p=0.000000,0.000000&speed=0&direction=0.000000&p=41.908425,-87.836390&speed=37&direction=268.300000
    },

    handleClickDownload() {
      saveAs(this.video.mp4, this.video.content_id);
    },

    async handleClickDelete() {
      Modal.confirm({
        title: 'Do you want to delete these items?',
        icon: createVNode(ExclamationCircleOutlined),
        content: '',
        onOk: () => this.onDeleteConfirm(this.video._id),
        onCancel() {},
      });
    },

    async onDeleteConfirm(id) {
      try {
        const res = await productService.deleteVideo(id);
        if (res.r) {
          await new Promise((resolve, reject) => {
            setTimeout(() => resolve(), 1000); // 항상 resolve를 호출하도록 변경
          });
          Modal.destroyAll(); // 모달 닫기
          this.$router.push('/main');
        }
      } catch (error) {
        // 오류 처리
        console.error('Error during video deletion:', error);
      }
    }

  },
};

/*
{
    "r": true,
    "_id": "6459e399c031fc36e5b7e78f",
    "content_id": "EVT_2023_05_09_15_02_19_f-72.mp4",
    "member_no": "1677607468467",
    "node_id": 1,
    "trip_id": "20230509_145938_1615",
    "content_type": "Video",
    "daylight": true,
    "event_data": {
        "gyro": "  ",
        "speed": {
            "value": "",
            "unit": "mph"
        },
        "altitude": 0,
        "latitude": "",
        "longitude": "",
        "direction": 0
    },
    "incident_time": 1,
    "byte": 41943040,
    "duration": 20.066656,
    "mp4": "https://s3.us-west-1.amazonaws.com/private-file.echomasteropsis.com/media/1677607468467/EVT_2023_05_09_15_02_19_f-72.mp4?AWSAccessKeyId=AKIATLHAQ2YJBF7GIBUH&Expires=1685155277&Signature=D45rDXxHrarREx%2F6OHIC7d8lN64%3D",
    "preview": "https://s3.us-west-1.amazonaws.com/private-file.echomasteropsis.com/media/1677607468467/preview_6459e399c031fc36e5b7e78f.png?AWSAccessKeyId=AKIATLHAQ2YJBF7GIBUH&Expires=1685155277&Signature=qDi4tGjL1GqDwwJOC3Pyh90fQwA%3D",
    "preview_byte": 125274,
    "preview_process": "complete",
    "device_serial": "AA0P20M99977",
    "text1": "09 May 2023",
    "text2": "PM 2:59",
    "byte_text": "41.94 MB"
}
*/
</script>

<style lang="scss" scoped>

.empty_height2 {
  height: 42px;
  @media (max-width: 768px) {
    height:50px;
  }
}
.empty_height {
  height: 42px;
  @media (max-width: 768px) {
    height: 0px;
  }
}
.replay-view-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 32px;
  margin-top: 162px;

  @media (max-width: 768px) {
    margin-top: 0px;
    flex-wrap: wrap;
  }

  .player-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 460px;
    font-size: 16px;

    @media (max-width: 768px) {
      font-size: 12px;
    }

    .player {
      display: flex;
      width: 100%;
      height: 100%;
    }
  }

  .map-wrapper {
    width: 100%;
    height: 460px;
    display: flex;
    flex-direction: column;
    @media (max-width: 768px) {
      height: 410px;
      margin-bottom: 40px;
    }
  }
}
</style>
